import axios from 'axios'

const HEADER = 'Authorization'

const axiosApi = axios.create({
  // timeout: 30 * 1000,
  headers: { common: { } },
})

export function setAuthToken(token) {
  if (token) {
    axiosApi.defaults.headers.common[HEADER] = `Bearer ${token}`
  } else {
    delete axiosApi.defaults.headers.common[HEADER]
  }
}

export default axiosApi
